import './360ty_styles.scss'
import Pano_360ty from './class-tourbuilder-360ty';
//@ts-ignore
if(typeof window !=='undefined')window.Pano_360ty = Pano_360ty;
